/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_REPLY': {
    width: 16,
    height: 16,
    viewBox: '0 0 153 101',
    data: '<path pid="0" _fill="currentColor" d="M152.68 96.66c-14.8-45.78-61.16-65.11-89.09-72.77a1.53 1.53 0 0 1-1.14-1.5v-19A3.3 3.3 0 0 0 59.22.05a3.42 3.42 0 0 0-.79.08 3.19 3.19 0 0 0-1.33.62L1.47 44.39A3.31 3.31 0 0 0 .83 49a3.37 3.37 0 0 0 .62.63l55.63 44.69a3.3 3.3 0 0 0 4.64-.52 3.28 3.28 0 0 0 .73-2.06V72.85A1.55 1.55 0 0 1 64 71.29c12.25.15 53.38 2.53 83.41 28.9a3.25 3.25 0 0 0 2.1.76h.32a3.3 3.3 0 0 0 2.83-4.28zm-93.74-32A3.3 3.3 0 0 0 55.85 68v12.63a1.57 1.57 0 0 1-2.53 1.23L8.39 49.31a1.56 1.56 0 0 1 0-2.45l44.93-34.67a1.56 1.56 0 0 1 2.53 1.22L55 28.58a3.29 3.29 0 0 0 2.48 3.2c22.52 5.74 57.85 13.47 77.18 46.56a1.57 1.57 0 0 1-2.15 2.14c-30.14-18.37-59.88-15.84-70.36-15.84-1.82 0-2.93.04-3.21.06z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_REPLY.js